import { useState, useEffect, useRef, useCallback ,} from "react";
import {
  Box,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton,
  Button,
  CircularProgress,
  InputBase,
  Pagination,
  TableBody,
  Menu,MenuItem
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CustomText, { textStyles } from "../../../components/CustomText";
import tablefilter from "../../../assets/tablefilter.svg";
import { pdf } from "@react-pdf/renderer";
import eye from "../../../assets/Wallet/eye.svg";
import WalletDetails from "../Wallet/MyWallet/WalletDetails";
import RequestPayoutDrawer from "../Wallet/MyWallet/RequestDrawer";
import FilterDrawer from "../Wallet/MyWallet/FilterDrawer";
import MyWalletPDF from "../Wallet/MyWallet/MyWalletPDF";
import StatusDropdown from "../../../components/StatusDropdown";
import ExportDropdown from "../../../components/ExportDropdown";
import VisibilityIcon from "@mui/icons-material/Visibility";
import NorthIcon from "@mui/icons-material/North";
import SouthIcon from "@mui/icons-material/South";
import { useTranslation } from "react-i18next";
import { BASE_URL } from "../../../components/BaseUrl";
import { decryptToken } from "../../../Utlis/Encryption";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import table1 from "../../../assets/Dashboard/table1.svg";
import table2 from "../../../assets/Dashboard/table2.svg";
import {showUnderDevelopment} from "../../../components/alerts";
import { useNavigate } from 'react-router-dom';
import emptyscreen from "../../../assets/Dashboard/emptyscreen.svg";
import { convertUTCToLocalDateTime } from "../../../components/dateTime";
const PayoutLogsTable = () => {
  const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;
  const [tableProcessing, setTableProcessing] = useState(false);
  const [firstLoadDone, setFirstLoadDone] = useState(false);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortLoading, setSortLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const [sortConfig, setSortConfig] = useState({ key: "paymentDate", direction: "desc" });
  const [totalRows, setTotalRows] = useState(0);
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");
  const [tableRows, setTableRows] = useState([]);
  const [originalData, setOriginalData] = useState([]);
const navigate=useNavigate()
  const [filters, setFilters] = useState({
    plan_name: [],
    commission_status: [],
    date_from: "",
    date_to: "",
  });

  const backendSortKeyMap = {
    id: "payout_id",
    companyName: "company_name",
    batchId: "paypal_batch_id",
    payoutAmount: "payout_amount",
    method: "method",
    paymentDate: "payout_date",
    email: "recipient_email",
    status: "payout_status",
  };

  const columns = [
    { key: "id", label: t("managePayout.id") },
    { key: "companyName", label: t("walletDetails.companyName") },
    { key: "batchId", label: t("walletDetails.paypalBatchId") },
    { key: "payoutAmount", label: t("managePayout.payout_amount") },
    { key: "method", label: t("managePayout.method") },
    { key: "paymentDate", label: t("managePayout.payment_date") },
    { key: "email", label: t("managePayout.email") },
    { key: "status", label: t("managePayout.status") },
    { key: "action", label: t("managePayout.action") },
  ];

  const handleSort = (key) => {
    // Disable the main loading and enable sort loading
    setLoading(false);
    setSortLoading(true);
    
    const newDirection = sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
    setSortConfig({ key, direction: newDirection });
    setPage(0);
  };

  const fetchPayouts = useCallback(async () => {
    // Only set loading if we're not in a sort operation
     const isInitialLoad = !firstLoadDone;

  if (isInitialLoad) {
    setLoading(true);
  } else {
    setTableProcessing(true);
  }
    
    try {
      const queryParams = new URLSearchParams();
      queryParams.append('page', page + 1);
      queryParams.append('limit', rowsPerPage);

      if (filters.plan_name && filters.plan_name.length > 0) {
        queryParams.append('plan_name', filters.plan_name.join(','));
      }
      if (filters.commission_status && filters.commission_status.length > 0) {
        queryParams.append('commission_status', filters.commission_status.join(','));
      }
      if (filters.date_from) {
        queryParams.append('date_from', filters.date_from);
      }
      if (filters.date_to) {
        queryParams.append('date_to', filters.date_to);
      }

      if (searchTerm) {
        queryParams.append('search', searchTerm);
      }

      const backendSortKey = backendSortKeyMap[sortConfig.key] || sortConfig.key;
      queryParams.append('sort_by', backendSortKey);
      queryParams.append('sort_order', sortConfig.direction);

      const res = await fetch(
        `${BASE_URL}/payments/account-exec/payout-history?${queryParams.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = await res.json();

      const payouts = result?.data?.payouts || [];
      const formatted = payouts.map((item) => ({
        id: item.payout_id,
        commissionID: item.commission_id,
        batchId: item.paypal_batch_id,
        paypalTransactionId: item.paypal_transaction_id,
        paypalFee: item.paypal_fee,
        payoutStatus: item.payout_status,
     payoutDate: convertUTCToLocalDateTime(item.payout_date),
        companyName: item.company_name,
        planName: item.plan_name,
        commissionRate: item.commission_rate != null ? `${Math.round(item.commission_rate)}%` : "-",
        planAmount: `${item.currency} ${item.plan_amount}`,
        payoutAmount: `${item.currency} ${item.payout_amount}`,
        method: "Paypal",
        receipt: eye,
   paymentDate: convertUTCToLocalDateTime(item.payout_date),
        email: item.recipient_email || "-",
        status: item.payout_status,
        originalDate: new Date(item.payout_date)
      }));

      setOriginalData(formatted);
      setTableRows(formatted);
      setTotalRows(result?.data?.pagination?.total || 0);
    } catch (error) {
      console.error("Failed to fetch payout data:", error);
    } finally {
      setLoading(false);
    setTableProcessing(false);
    setFirstLoadDone(true);  
    }
  }, [page, rowsPerPage, filters, searchTerm, sortConfig, token, sortLoading]);
  // const isFilterApplied = Object.values(filters).some(f => f && f !== '');
  const isFilterApplied = Object.entries(filters).some(([key, value]) => {
  if (Array.isArray(value)) return value.length > 0;
  return value !== '';
});
  useEffect(() => {
    fetchPayouts();
  }, [fetchPayouts]);

  const HaederStyles = {
    color: "#44546F",
    fontSize: "13px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600,
  };

  const DataStyles = {
    color: "#172B4D",
    fontSize: "13px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 400,
      whiteSpace: 'nowrap', // ✅ Prevent text wrap
   
      overflow: 'hidden',
  textOverflow: 'ellipsis',
  };

  // const paginatedRows = tableRows;
  const filteredRows = tableRows.filter((row) =>
  Object.values(row).some(
    (val) =>
      val &&
      typeof val === "string" &&
      val.toLowerCase().includes(searchTerm.toLowerCase())
  )
)

const paginatedRows = filteredRows

  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);

  const handleApplyFilters = (appliedFilters) => {
    setFilters(appliedFilters);
    setFilterDrawerOpen(false);
    setPage(0);
  };

  const handleClearAllFilters = (clearedFilters) => {
    setFilters(clearedFilters);
    setFilterDrawerOpen(false);
    setPage(0);
  };
// const paginatedRows = tableRows
// const totalPages = Math.ceil(totalRows / rowsPerPage)
const totalPages = Math.ceil(filteredRows.length / rowsPerPage);
const searchTimeout = useRef(null);
const handleSearchChange = (e) => {
  const value = e.target.value;
  clearTimeout(searchTimeout.current);
  searchTimeout.current = setTimeout(() => {
    setSearchTerm(value);
    setPage(0);
  }, 400); // 400ms debounce delay
};

const menuAnchorsRef = useRef({});
const [anchorEl, setAnchorEl] = useState(null);
const [menuRowId, setMenuRowId] = useState(null);
const selectedRowFromMenu = tableRows.find((r) => r.id === menuRowId);


  return (
    <Box sx={{ py: 0, px: 1 }}>
      <Box sx={{ backgroundColor: "#fff", borderRadius: 2, py: 2, border: "1px solid #E4E6EF" }}>
        <Box
          sx={{
            display: "flex",
            flexWrap:"wrap",
            alignItems: "center",
            justifyContent: "space-between",
            px: 2,
           
            mb: 2,
            gap: 1,
          }}
        >
          <Box sx={{ flex: 1, display: "flex",
             alignItems: "center", gap: 1 }}>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontWeight: 600,
                fontSize: "18px",
                color: "#003149",
                textAlign: "left",
              }}
            >
                  {t("payoutLogs")}
            </CustomText>
            {/* {tableProcessing && <CircularProgress size={16} sx={{ color: "#006EC2" }} />} */}
            {tableProcessing && (
  <CircularProgress
    size={18}
    thickness={4}
    sx={{ color: '#006EC2' }}
  />
)}
          </Box>

          {/* <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
            }}
          > */}
            <Box
              sx={{
                px: 0.5,
                py: 0.2,
                borderRadius: 1,
                height: 34,
                border: "2px solid #091E4224",
                display: "flex",
                alignItems: "center",
                minWidth: 250,
              }}
            >
              <InputBase
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setPage(0);
                }}
  //                 value={searchTerm}
  // onChange={handleSearchChange}
                placeholder={t("commissionRecord.searchPlaceholder")}
                sx={{
                  ml: 0.5,
                  fontSize: 15,
                  letterSpacing: "1px",
                  color: "#939393",
                  fontWeight: 500,
                  width: "100%",
                }}
              />
              <SearchIcon sx={{ fontSize: 22, color: "#888", mr: 0.5 }} />
            </Box>
          {/* </Box> */}

          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: 1,
            }}
          >
            {selected.length === 0 && (
              <>
              
             <Box sx={{display:"flex",gap:0.5}}>
    <img src={table2}
    onClick={() =>
  navigate('/my-wallet', {
    state: { fromDashboard: true, scrollToId: 'wallet-table' }
  })
}/>
      </Box>
 
              </>
            )}
          </Box>
        </Box>

        {/* Show loading spinner for initial load/filter changes */}
        {loading && (
          <Box sx={{ height: "40vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <CircularProgress size={40} sx={{ color: "#006EC2" }} />
          </Box>
        )}

        {/* Show table content when not loading (either initial load or sorting) */}
        {!loading && (
          <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
            <Table size="small">
              <TableHead sx={{
                  whiteSpace: 'nowrap', // ✅ Prevent text wrap
   
      overflow: 'hidden',
  textOverflow: 'ellipsis',
              }}>
                <TableRow>
                  {columns.map((col) => (
                    <TableCell key={col.key} sx={{ ...HaederStyles, py: "6px", px: "2px" }}>
                      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        {col.label}
                        {col.key !== "action" && (
                          <IconButton onClick={() => handleSort(col.key)}>
                            {sortConfig.key === col.key ? (
                              sortConfig.direction === "asc" ? (
                                <NorthIcon sx={{ fontSize: "12px", }} />
                              ) : (
                                <SouthIcon sx={{ fontSize: "12px",  }} />
                              )
                            ) : (
                              <SouthIcon sx={{ fontSize: "12px",  }} />
                            )}
                          </IconButton>
                        )}
                      </Box>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
<TableBody>
  {paginatedRows.length === 0 ? (
    <TableRow>
      <TableCell colSpan={columns.length} align="center" sx={{ py: 4 }}>
           <Box sx={{ display: 'flex',flexDirection:"column" ,justifyContent: 'center', alignItems: 'center', height: 300 }}>
          <img src={emptyscreen} alt="No Data" style={{ width: 200,  }} />
            <CustomText
    sx={{
      ...textStyles.h1,
      fontWeight: 500,
      fontSize: '16px',
      color: '#003149',
      pt:1,
    }}
  >
  {t('empty.no_user')}
  </CustomText>

        </Box>
      </TableCell>
    </TableRow>
  ) : (
    paginatedRows.map((row) => (
      <TableRow key={row.id} hover>
        <TableCell sx={{ ...DataStyles, pl: 2 }}>{row.id}</TableCell>
        <TableCell sx={{ ...DataStyles, textAlign: "center" }}>{row.companyName}</TableCell>
        <TableCell sx={{ ...DataStyles, textAlign: "center" }}>{row.batchId}</TableCell>
        <TableCell sx={DataStyles}>{row.payoutAmount}</TableCell>
        <TableCell sx={DataStyles}>{row.method}</TableCell>
        <TableCell sx={DataStyles}>{row.paymentDate}</TableCell>
        <TableCell sx={{ ...DataStyles, textAlign: "center" }}>{row.email}</TableCell>
        <TableCell sx={DataStyles}>
          <Box sx={{ pointerEvents: "none" }}>
            <StatusDropdown currentStatus={row.payoutStatus} />
          </Box>
        </TableCell>
        <TableCell sx={DataStyles}>
          <IconButton
            ref={(el) => {
              if (el) menuAnchorsRef.current[row.id] = el;
            }}
            onClick={() => {
              setAnchorEl(menuAnchorsRef.current[row.id]);
              setMenuRowId(row.id);
            }}
          >
            <MoreVertIcon fontSize="small" sx={{ fontSize: "22px" }} />
          </IconButton>
        </TableCell>
      </TableRow>
    ))
  )}
</TableBody>

            </Table>
          </TableContainer>
          
        )}
        
                                                 <Menu
                   sx={{fontSize:"15px",boxShadow:"none"}}
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={() => setAnchorEl(null)}

                    anchorOrigin={{
    vertical: 'bottom',
    horizontal: 'center',
  }}
  transformOrigin={{
    vertical: 'top',
    horizontal: 'center',
  }}
                    PaperProps={{
                    sx: {
                      // minWidth: 80,
                      // paddingY: 0.5,
                      // boxShadow:"none",
                      // border: '1px solid #E0E0E0',
                    },
                  }}
                  MenuListProps={{
                    sx: {
                      paddingY: 0,
                    },
                  }}
                >
                  <MenuItem    onClick={() => {
    setSelectedRow(selectedRowFromMenu); // ✅ same as icon onClick
    setAnchorEl(null); // ✅ close menu
    setMenuRowId(null); // ✅ cleanup
  }}
  sx={{fontSize:"14px",
                       fontFamily: 'Poppins, sans-serif',
                  }}>{t("common.view")}</MenuItem>
                </Menu>

             <Box sx={{ display: 'flex',flexWrap:"wrap", justifyContent: 'center', mt: 2 }}>
            <Pagination
  count={totalPages}
  page={page + 1}
  onChange={(e, value) => setPage(value - 1)}
  shape="rounded"
  color="primary"
  size="small"
  sx={{
    '& .MuiPaginationItem-root': {
      fontFamily: 'Poppins, sans-serif',
      fontSize: 13,
      fontWeight: 500,
    },
    '& .Mui-selected': {
      backgroundColor: '#E9F3FF',
      color: '#006EC2',
    },
  }}
/>
</Box>
      </Box>

      <RequestPayoutDrawer open={openDrawer} onClose={() => setOpenDrawer(false)} />
      <WalletDetails open={!!selectedRow} onClose={() => setSelectedRow(null)} selectedRow={selectedRow} />
      <FilterDrawer
        open={filterDrawerOpen}
        onClose={() => setFilterDrawerOpen(false)}
        initialFilters={filters}
        onApplyFilters={handleApplyFilters}
        onClearAllFilters={handleClearAllFilters}
      />
    </Box>
  );
};

export default PayoutLogsTable;








